// Author YuJiaBei
// Date 2021-01-21 08:15:33

class SithMesPrdPpOperationSchedulePos {
constructor({
        id = null,
        posIdOperation = '',
        posIdMstLocation = '',
        posForecastBeginTime = '',
        posForecastEndTime = '',
        posForecastWorkHour = '',
        remark = ''}
= {}) {
    this.id = id;
    this.posIdOperation = posIdOperation;
    this.posIdMstLocation = posIdMstLocation;
    this.posForecastBeginTime = posForecastBeginTime;
    this.posForecastEndTime = posForecastEndTime;
    this.posForecastWorkHour = posForecastWorkHour;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdPpOperationSchedulePos();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'posIdOperation',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.posIdOperation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'posIdMstLocation',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.posIdMstLocation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'posForecastBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.posForecastBeginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'posForecastEndTime',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.posForecastEndTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'posForecastWorkHour',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.posForecastWorkHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationHeadCount',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.operationHeadCount',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationMissionMode',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.operationMissionMode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationIsLocked',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.operationIsLocked',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationStatus',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.operationStatus',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationSeq',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.operationSeq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'headerId',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.headerId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'headerWbsCode',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.headerWbsCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'headerOrderCode',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.headerOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    posIdOperationFilter : "",
    posIdMstLocationFilter : "",
    posForecastBeginTimeRteFilter : "",
    posForecastBeginTimeLteFilter : "",
    posForecastEndTimeRteFilter : "",
    posForecastEndTimeLteFilter : "",
    posForecastWorkHourFilter : "",
    operationMissionModeFilter : "",
    operationIsLockedFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'posIdOperationFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.filter.posIdOperation',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'posIdMstLocationFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.filter.posIdMstLocation',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'posForecastBeginTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.filter.posForecastBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'posForecastBeginTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.filter.posForecastBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'posForecastEndTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.filter.posForecastEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'posForecastEndTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.filter.posForecastEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'posForecastWorkHourFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.filter.posForecastWorkHour',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'operationMissionModeFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.filter.operationMissionMode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'operationIsLockedFilter',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.filter.operationIsLocked',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'posIdOperation',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.entity.posIdOperation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'posIdMstLocation',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.entity.posIdMstLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'posForecastBeginTime',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.entity.posForecastBeginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'posForecastEndTime',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.entity.posForecastEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'posForecastWorkHour',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.entity.posForecastWorkHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdPpOperationSchedulePos.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdPpOperationSchedulePos, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
